const CHILI_PIPER_SCRIPT_ID = "chilipiper-concierge";
const CHILI_PIPER_SCRIPT_URL =
  "https://circle-co.chilipiper.com/concierge-js/cjs/concierge.js";

export const loadChiliPiperScript = (): Promise<void> =>
  new Promise((resolve, reject) => {
    if (window.ChiliPiper) {
      resolve();
      return;
    }

    const existingScript = document.getElementById(CHILI_PIPER_SCRIPT_ID);
    if (existingScript) {
      existingScript.addEventListener("load", () => resolve());
      existingScript.addEventListener("error", reject);
      return;
    }

    const script = document.createElement("script");
    script.id = CHILI_PIPER_SCRIPT_ID;
    script.src = CHILI_PIPER_SCRIPT_URL;
    script.crossOrigin = "anonymous";
    script.type = "text/javascript";

    script.onload = () => resolve();
    script.onerror = reject;

    document.head.appendChild(script);
  });
